import type {SaveState} from 'shells/saved-setting-toast/use-manage-save-state';
import {LabelWithContent} from 'shells/typography/label-with-content';

import type {ChatAssignmentStrategyEnum} from 'nutshell-graphql-types';
import type {ThreadType} from 'nutshell-graphql-types';

import {AssignmentRules} from '.';

interface Props {
    hasNewColumnLayout: boolean;
    threadType: ThreadType;
    handleSaveAssignRules: (value: ChatAssignmentStrategyEnum, assigneeId?: string | null) => void;
    selectedValue: ChatAssignmentStrategyEnum;
    assignedUserId: string | null;
    setAssignmentRule: (value: ChatAssignmentStrategyEnum) => void;
    savingToastKey: string;
    toastState: SaveState;
}

export const InboundMessageAssignment = (props: Props) => {
    return props.hasNewColumnLayout ? (
        <AssignmentRules
            handleSaveAssignRules={props.handleSaveAssignRules}
            selectedValue={props.selectedValue}
            assignedUserId={props.assignedUserId}
            setSelectedValue={props.setAssignmentRule}
            threadType={props.threadType}
            hasNewColumnLayout={props.hasNewColumnLayout}
        />
    ) : (
        <LabelWithContent
            label={`Inbound message assignment`}
            spacing={8}
            state={props.savingToastKey === 'inbound-sms-assignment' ? props.toastState : 'initial'}
            isFullHeight={true}
            content={
                <AssignmentRules
                    handleSaveAssignRules={props.handleSaveAssignRules}
                    selectedValue={props.selectedValue}
                    assignedUserId={props.assignedUserId}
                    setSelectedValue={props.setAssignmentRule}
                    threadType={props.threadType}
                />
            }
        />
    );
};
